import { createReducer, on } from '@ngrx/store';
import { AuthState } from '../../models/auth.model';
import * as AuthActions from './auth.actions';

export const initialState: AuthState = {
  user: null,
  accessToken: null,
  refreshToken: null,
  balance: null,
  aiJob: null,
  socialRegistered: false,
  socialMerged: false,
  socialLogged: false,
  loading: false,
  error: null
};

export const authReducer = createReducer(
  initialState,

  // Initialize
  on(AuthActions.getCurrentUser, (state) => ({
    ...state,
    loading: true,
    error: null
  })),

  on(AuthActions.getCurrentUserSuccess, (state, { user }) => ({
    ...state,
    user,
    loading: false,
    error: null
  })),

  on(AuthActions.getCurrentUserFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error
  })),

  on(AuthActions.setUser, (state, { user }) => ({
    ...state,
    user,
    loading: false,
    error: null
  })),

  on(AuthActions.setUserHints, (state, { userHints }) => ({
    ...state,
    userHints,
    loading: false,
    error: null
  })),

  on(AuthActions.getUserHints, (state) => ({
    ...state,
    loading: true,
    error: null
  })),

  on(AuthActions.setUserBalance, (state, { balance }) => ({
    ...state,
    balance,
    loading: false,
    error: null
  })),

  on(AuthActions.getUserBalance, (state) => ({
    ...state,
    loading: true,
    error: null
  })),

  on(AuthActions.setUserAIJob, (state, { aiJob }) => ({
    ...state,
    aiJob,
    loading: false,
    error: null
  })),

  on(AuthActions.getUserAIJob, (state) => ({
    ...state,
    loading: true,
    error: null
  })),

  on(AuthActions.noStoredToken, (state) => ({
    ...state,
    loading: false,
    error: null
  })),

  // Login
  on(AuthActions.login, (state) => ({
    ...state,
    loading: true,
    error: null
  })),

  on(AuthActions.loginSuccess, (state, { user, accessToken, refreshToken, socialRegistered, socialMerged, socialLogged }) => ({
    ...state,
    user,
    accessToken,
    refreshToken,
    socialRegistered,
    socialMerged,
    socialLogged,
    loading: false,
    error: null
  })),

  on(AuthActions.loginFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error
  })),

  // Register
  on(AuthActions.register, (state) => ({
    ...state,
    loading: true,
    error: null
  })),

  on(AuthActions.registerSuccess, (state, { user, accessToken, refreshToken }) => ({
    ...state,
    user,
    accessToken,
    refreshToken,
    loading: false,
    error: null
  })),

  on(AuthActions.registerFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error
  })),

  // Logout
  on(AuthActions.logout, (state) => ({
    ...state,
    loading: true,
    error: null
  })),

  on(AuthActions.logoutSuccess, () => ({
    ...initialState
  })),

  on(AuthActions.clearAuthError, (state) => ({
    ...state,
    error: null
  }))
);
